import { render, staticRenderFns } from "./Producers.vue?vue&type=template&id=750dd004&scoped=true&"
import script from "./Producers.vue?vue&type=script&lang=js&"
export * from "./Producers.vue?vue&type=script&lang=js&"
import style0 from "./Producers.vue?vue&type=style&index=0&id=750dd004&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750dd004",
  null
  
)

export default component.exports